import { FooterClass } from "../helpers/constant";
import Vue from "vue";
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    async resetToolTipHeight(paddingHeight) {
      await Vue.nextTick();
      const hoverElement = this.$refs.hover;
      const footerLine = document.getElementsByClassName(FooterClass);
      if (footerLine && footerLine.length > 0)
        if (hoverElement) this.hoverHeight = Number(hoverElement.clientHeight);
      let scrollPosition = document.documentElement.scrollTop;
      let shiftTop =
        Number(footerLine[0].offsetTop) -
        (this.mouse.pageY - scrollPosition) -
        (this.hoverHeight + paddingHeight);
      if (shiftTop < 0) {
        this.mouse.pageY = this.mouse.pageY + shiftTop;
      }
    },
  },
};
